<div class="content" *ngIf="trainsInfo as t">
  <div class="master-container">
    <ng-container *ngFor="let trip of [
    { type: 'outward', train: t.selectedTrains.selectedOutwardTrain },
    { type: 'return', train: t.selectedTrains.selectedReturnTrain }
    ]">
      <h5 *ngIf="trip.type === 'outward' || !t.searchConfig.oneWay">
        {{ trip.type === 'outward'
        ? ('train.search-result.outward-train' | translate)
        : ('train.search-result.return-train' | translate) }}
      </h5>
      <div *ngFor="let section of trip.train?.sections">
        <div class="train-container" *ngFor="let alternative of section.alternatives">
          <div>
            <div class="header">
              <div class="search-data">
                <span>{{ alternative.origin }} - {{ alternative.destination }}</span>
                <span>{{ alternative.departDate | date }}</span>
              </div>
            </div>
            <div class="info-container">
              <div class="extras-container" *ngIf="thereIsExtras(alternative)">
                <p>{{ 'train.confirm-stepper-container.stepper.extra-selection' | translate }}</p>
                <div *ngFor="let extra of alternative.extras">
                  <label>
                    <button mat-mini-fab (click)="selectExtra('remove', extra, section.sectionId, trip.type)"
                      [disabled]="isSelectDisabled('remove', extra, section.sectionId, trip.type)">
                      <mat-icon>-</mat-icon>
                    </button>
                    <span>
                      {{ extra.description }}
                      {{ extra.price > 0
                      ? '+ ' + extra.price + ' €'
                      : ('common.free' | translate) }}
                    </span>
                    <button mat-mini-fab (click)="selectExtra('add', extra, section.sectionId, trip.type)"
                      [disabled]="isSelectDisabled('add', extra, section.sectionId, trip.type)">
                      <mat-icon>+</mat-icon>
                    </button>
                  </label>
                </div>
              </div>
              <div class="seats-container">
                <p>{{ 'train.confirm-stepper-container.stepper.seat-selection' | translate }}</p>
                <mat-radio-group
                  [(ngModel)]="trip.type === 'outward' ? buttonsSeatOutward[section.sectionId] : buttonsSeatReturn[section.sectionId]">
                  <mat-radio-button *ngIf="alternative.seats?.length" value="select" (click)="openSeatModal(
                  trip.type === 'outward' ? 0 : 1,
                  section,
                  section.sectionId,
                  trip.train
                )">

                    {{ 'train.confirm-stepper-container.stepper.select-seat' | translate }}
                  </mat-radio-button>
                  <mat-radio-button value="preference" (click)="deleteSeats(trip.type, section.sectionId)">
                    {{ 'train.confirm-stepper-container.stepper.random-seat-selection' | translate }}
                  </mat-radio-button>
                </mat-radio-group>
                <p>{{ 'train.confirm-stepper-container.stepper.seat-preferences' | translate }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
  <div class="summary">
    <div class="fixed-footer">
      <app-trains-summary [activePage]="'extras'" [stepper]="stepper" (onSelectExtrasEvent)="onSelect()">
      </app-trains-summary>
    </div>
  </div>

</div>